// src/auth/context/jwt/faqs.js

import axios, { endpoints } from 'src/utils/axios';

/** GET FAQ CATEGORIES */
export const getFaqCategories = async ({ search }) => {
  try {
    let queryParams = '';
    if (search) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      queryParams = `?${params.toString()}`;
    }
    const res = await axios.get(`${endpoints.faq.get_faq_categories}${queryParams}`);
    return res;
  } catch (error) {
    console.error('Error getting FAQ categories:', error);
    throw error;
  }
};

/** GET FAQ CATEGORIES Dropdown */
export const getFaqCategoriesDropdown = async () => {
  try {
    const res = await axios.get(`${endpoints.faq.get_parent_categories_for_dropdown}`);
    return res;
  } catch (error) {
    console.error('Error getting FAQ categories dropdown:', error);
    throw error;
  }
};

/** Add/EDIT CATEGORY */
export const addFaqCategory = async ({ id, name, description }) => {
  try {
    const payload = {
      name,
      description,
    };

    // Edit case
    if (id) {
      payload.id = id;
    }

    const res = await axios.post(endpoints.faq.add_edit_parent_category, payload);

    return res;
  } catch (error) {
    console.error(`Error ${id ? 'updating' : 'adding'} category:`, error);
    throw error;
  }
};

// DELETE Category
export const delete_category = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    params.append('status', 27);
    queryParams = `?${params.toString()}`;
    const res = await axios.post(`${endpoints.faq.change_parent_category_status}${queryParams}`); // Append id to the endpoint
    return res; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting category:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// /////////////////. SUB CATEGORY

/** GET FAQ SUB CATEGORIES */
export const getFaqSubCategories = async ({ search }) => {
  try {
    let queryParams = '';
    if (search) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      queryParams = `?${params.toString()}`;
    }
    const res = await axios.get(`${endpoints.faq.get_sub_categories}`);
    return res;
  } catch (error) {
    console.error('Error getting FAQ sub categories:', error);
    throw error;
  }
};

/** GET FAQ CATEGORIES Dropdown */
export const getFaqSubCategoriesDropdown = async ({ category }) => {
  try {
    let queryParams = '';
    if (category) {
      const params = new URLSearchParams();
      if (category) params.append('parent_category_id', category);
      queryParams = `?${params.toString()}`;
    }
    const res = await axios.get(`${endpoints.faq.get_sub_categories_for_dropdown}${queryParams}`);
    return res;
  } catch (error) {
    console.error('Error getting FAQ sub categories dropdown:', error);
    throw error;
  }
};

/** Add/EDIT SUB CATEGORY */
export const addFaqSubCategory = async ({ id, name, description, parent_category_id }) => {
  try {
    const payload = {
      name,
      description,
      parent_category_id,
    };

    // Edit case
    if (id) {
      payload.id = id;
    }

    const res = await axios.post(endpoints.faq.add_edit_sub_category, payload);

    return res;
  } catch (error) {
    console.error(`Error ${id ? 'updating' : 'adding'} sub category:`, error);
    throw error;
  }
};

// DELETE SUB Category
export const delete_sub_category = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    params.append('status', 27);
    queryParams = `?${params.toString()}`;
    const res = await axios.post(`${endpoints.faq.change_sub_category_status}${queryParams}`); // Append id to the endpoint
    return res; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting sub category:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};
// END SUB CATEGORY

/** GET FAQS LIST */
export const getFaqsList = async ({ search, category, sub_category }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || category || sub_category) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (category) params.append('parent_category_id', category);
      if (sub_category) params.append('sub_category_id', sub_category);
      queryParams = `?${params.toString()}`;
    }
    // ?parent_category_id=&sub_category_id=&status=&search=

    const res = await axios.get(`${endpoints.faq.get_faqs}${queryParams}`);
    return res;
  } catch (error) {
    console.error('Error getting FAQs list:', error);
    throw error;
  }
};

/** CREATE FAQ */
export const add_edit_faq = async ({ id, category, sub_category, question, answer, media_ids }) => {
  try {
    const formData = new FormData();

    if (id) {
      formData.append('id', id);
    }
    if (category) formData.append('parent_category_id', category);
    if (sub_category) formData.append('sub_category_id', sub_category || '');
    if (question) formData.append('question', question);
    if (answer) formData.append('answer_text', answer);

    // backend expects: 1,2,3
    if (media_ids.length !== 0) formData.append('media_ids', media_ids.join(','));

    const res = await axios.post(endpoints.faq.add_edit_faq, formData);

    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/** DELETE FAQ */
export const deleteFaq = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    params.append('status', 27);
    queryParams = `?${params.toString()}`;
    const res = await axios.post(`${endpoints.faq.change_faq_status}${queryParams}`);
    return res;
  } catch (error) {
    console.error('Error deleting FAQ:', error);
    throw error;
  }
};

/** UPLOAD FAQ MEDIA */
export const uploadFaqMedia = async (formData) => {
  try {
    const res = await axios.post(`${endpoints.faq.upload_faq_media}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res;
  } catch (error) {
    console.error('Error uploading FAQ media:', error);
    throw error;
  }
};

// Member FAQS
/** GET MEMBER FAQS SEARCH LIST */
export const getFaqSearchList = async ({ search }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.faq.search_faq}${queryParams}`);
    return res;
  } catch (error) {
    console.error('Error getting questions list:', error);
    throw error;
  }
};

/** GET MEMBER FAQS LIST */
export const get_faq_by_category = async () => {
  try {
    const res = await axios.get(`${endpoints.faq.get_faq_by_category}`);
    return res;
  } catch (error) {
    console.error('Error getting faqs list:', error);
    throw error;
  }
};

/** GET MEMBER FAQS DETAILS */
export const get_faq_by_id = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.faq.get_faq_by_id}${queryParams}`);
    return res;
  } catch (error) {
    console.error('Error getting details:', error);
    throw error;
  }
};
